import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { CodeIcon, SmartphoneIcon, GlobeIcon, CpuIcon, LayersIcon } from 'lucide-react';
export function TrustBar() {
  const revealRef = useScrollReveal();
  const logos = [{
    icon: <GlobeIcon className="w-5 h-5" data-id="element-475" />,
    label: 'Google'
  }, {
    icon: <CpuIcon className="w-5 h-5" data-id="element-476" />,
    label: 'Gemini'
  }, {
    icon: <SmartphoneIcon className="w-5 h-5" data-id="element-477" />,
    label: 'PWA'
  }, {
    icon: <CodeIcon className="w-5 h-5" data-id="element-478" />,
    label: 'React'
  }, {
    icon: <LayersIcon className="w-5 h-5" data-id="element-479" />,
    label: 'TypeScript'
  }];
  return <section ref={revealRef} className="py-14 border-y border-gray-100/80 bg-gradient-to-r from-gray-50/50 via-white to-gray-50/50 overflow-hidden" data-id="element-480">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-481">
        <p className="reveal text-center text-[10px] font-semibold tracking-[0.25em] text-apple-gray uppercase mb-10" data-id="element-482">
          Technológie ktorým dôverujeme
        </p>
        <div className="reveal reveal-delay-1 flex flex-wrap justify-center items-center gap-12 md:gap-20" data-id="element-483">
          {logos.map((logo, i) => <div key={i} className="flex items-center gap-2.5 text-gray-400 hover:text-apple-black transition-all duration-500 group cursor-default" data-id="element-484">
              <span className="group-hover:scale-110 transition-transform duration-300" data-id="element-485">
                {logo.icon}
              </span>
              <span className="font-bold text-lg tracking-tight" data-id="element-486">
                {logo.label}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}